import {  useRef, useState } from "react";
import TableHeader from '../../../shared/table/TableHeader'
import CustomTable from '../../../shared/table/CustomTable'
import { Grid, Tooltip ,Chip, Box, Typography , InputLabel } from "@mui/material";
//import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import {LoadSubscribers , SelectedUser  ,  AssginmultiplesGroup} from '../../state/alertActions'
import RandomlyColoredAvatar from "../../../Layout/RandomlyColoredAvatar";
import ActivateCustomers from "./ActivateCustomers";
import AssginCustomers from './AssginCustomers';
import { useFormik } from "formik";
import FormikMultiple from "../../../shared/FormikMultiple";
import BlockIcon from '@mui/icons-material/Block';

import * as yup from "yup";

const styleLabel = {
  color: "#050D2E",
  fontSize: ".875rem",
  fontWeight: "550",
  letterSpacing: "-0.5px",
  lineHeight: "16px",
  marginBottom:"8px",

}

const columnDefaults = {
  sortable: false,
  flex: 1,
  filterable: true,
  minWidth: 200,
};

const ActiveUser = "ACTIVE"

/**
 * Required:
 
1 is message genderated 
2  is message pending
0 is message failed
   */

const defaultColumns = [
  {
    ...columnDefaults,
    field: "id",
    headerName: "ID",
    sortable:true,
    
  },
  {
    ...columnDefaults,
    field: "name",
    headerName: "Customer Name",
     renderCell:(params) => (
      <Tooltip title={params.value}>
      
      <Box display={"flex"} gap="8px" className="table-cell-trucate">
      <RandomlyColoredAvatar name={`${params.value}`} size={25} />
        {params.value}
        {params?.row?.status === ActiveUser ? '' : <BlockIcon fontSize="small"/> }
        </Box>
    </Tooltip>
  ), 
    sortable: true,
   
  },
  {
    ...columnDefaults,
    field: "groups",
    headerName: "Customer Group",
    sortable: true,
    
    renderCell: (params) => {
      
      return(
        <Box display={"flex"} gap="5px" alignItems={"center"}>
        
      
        <Typography>{params?.value && params.value[0].name}</Typography>
        <Chip
              label={params?.value  ? 
                 params?.value.length === 1  ? params?.value?.length :  `+${params?.value?.length - 1}` 
                : params?.row?.type === "GROUP" ? "No Group" : "individual"}
              sx={{
                height: "20px",
                borderRadius:"10px",
                width:"auto",
                backgroundColor:"#E7E9EF",
                display: params.value ? params.value.length === 1 ? "none" : "inherit" : "inherit"
              }}
              />
              </Box>
      )
    },
  },

  {
    ...columnDefaults,
    field: "email",
    headerName: "Email",
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span className="table-cell-trucate">{params.value}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    ...columnDefaults,
    field: "emailCC",
    headerName: "Email CC",
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span className="table-cell-trucate">{params.value}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    ...columnDefaults,
    field: "account",
    headerName: "Account No.",
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span className="table-cell-trucate">{params.value}</span>
      </Tooltip>
    ),
    sortable: true,
  },

  {
    ...columnDefaults,
    field: "status",
    headerName: "Status",
    renderCell: (params) => (
      <Chip
      label={params?.value === ActiveUser ? "Active" : "Inactive"}
      sx={{
        height: "20px",
        borderRadius:"10px",
        width:"42%",
        backgroundColor:params.value === ActiveUser ? "#E5F6E4"  : "#FFD8D6"
      }}
      />
     ),
    sortable: true,
  },
];

const allColumns = [
  ...defaultColumns,
  {
    ...columnDefaults,
    field: "phoneNumber",
    headerName: "Phone Number",
    filterable:false
  },
];

const persistColumns = (columns) => {
  localStorage.setItem(
    "CustomersColumns",
    JSON.stringify(columns.map((c) => c.field))
  );
  };

  const loadPersistentColumns = () => {
    const persistentColumns = JSON.parse(
      localStorage.getItem("CustomersColumns")
    );
    if (persistentColumns) {
      return allColumns
        .filter((c) => persistentColumns.includes(c.field))
        .sort(
          (a, b) =>
            persistentColumns.indexOf(a.field) -
            persistentColumns.indexOf(b.field)
        );
    }
    return defaultColumns;
  };


const CustomersList = ({data,error,success, setDrawer , Groups , filterValue}) => {


  const {rows ,updatedAt , processing , pageSize , pageNumber , totalItems , totalPages}
   = useSelector((state) => state.CustomerList);
 


   const validationSchema = yup.object().shape({ 
Groups:yup.array().min(1).required().nullable()
  })


  

  const persistentColumns = loadPersistentColumns()
  
 

  
  const [tableRef, setTableRef] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [columns, setColumns] = useState(persistentColumns);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewRows, setViewRows] = useState([]);
  const [isActiveOpen, SethandleActivateCustomersOpen] = useState({status:false,Type:""})
  const [isAssginOpen, SethandleIsAssginOpen] = useState(false)
  const [touched, setTouched] = useState(false)
  const dispatch = useDispatch()





  const formik = useFormik({
    enableReinitialize:true,
    validateOnChange:true,
    validateOnBlur:false,
    initialValues: {
      Groups:[]
  
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let data = {
       /*  "groups":values.Groups.map((group) => group.id),
        "customers":selectedRowsWithDetails.map((element) => (element.customerId)) */
        groups:values.Groups.map((group) => group.id),
        customers:selectedRowsWithDetails.map((element) => (element.id))
        
      }
  dispatch(AssginmultiplesGroup(data,success,error)).then(()=>{
    dispatch(LoadSubscribers(
      {
        pageNumber,
      pageSize,
    },error))
    SethandleIsAssginOpen(false)
    setSelectedRows([])
    formik.resetForm()
}) 
  
  }
  
  })


/*   const onBeforeGetContentResolve = useRef(null); */
  const customizationRef = useRef(null);
  const onSelectionChange = (rows) => {
    setSelectedRows(rows);
  };

  

  const handleColumnsChange = (items) => {
    setColumns([...items]);
    persistColumns(items);
  };

  const handlePaginationChange = (paginationFilter) => {
   dispatch(LoadSubscribers({
      pageNumber,
      pageSize,
      ...paginationFilter,
    
   },
       
      )
    )
  }; 

  /* const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => {
      togglePrint((show) => !show);
      onBeforeGetContentResolve.current = resolve;
    });
  }; */


  const handleShowColumns = () => {
    setAnchorEl(customizationRef.current);
  };

  const handleColumnHide = (field) => {
    const filteredColumns = columns.filter((column) => column.field !== field);
    setColumns([...filteredColumns]);
    persistColumns(filteredColumns);
  };




  const onRowClick = (row) => {
    setViewRows([row]);
    dispatch(SelectedUser(row))
    setDrawer(true)
  };




/*   useEffect(() => {
    if (showPrint) onBeforeGetContentResolve.current();
  }, [showPrint, onBeforeGetContentResolve]); */

  const selectedRowsWithDetails = rows
    .filter((row, index) => selectedRows.includes(row.id))
    .map((row, index) => ({
      ...row,
      id: row.id,
        })); 


const Rows = filterValue.id === "All" ? rows.map((row, index) => ({
  ...row,
  id:row.id,
}))  :  rows.filter((row) => row.status === filterValue.id).map((row, index) => ({
  ...row,
  id:row.id,
}))       

   /* const checkView = 
    rows.filter((row, index) => selectedRows.includes(`${row.transactionId}-${index}`))
    .map((row, index) => (row.generated)).includes(sentSuccess);  */
  return (
<>

<Grid
        container
        spacing={2}
        padding={3}
      >
        <Grid item xs={12}>
          <TableHeader
       defaultColumns={defaultColumns}
       allColumns={allColumns}
       inUseColumns={columns}
       numberOfRows={Rows.length}
       numberOfSelectedRows={selectedRows.length}
       handleColumnsChange={handleColumnsChange}
       handleActivateCustomers={SethandleActivateCustomersOpen}
       handleIsAssginOpen={() => SethandleIsAssginOpen(true)}
       isPrint = {false}
       isMail = {false} 
      isActive = {true}
      isView = {false}
      isDeactive = {true}
      isAssgin={true}
       isHistory = {false}
       isReGenerate={false}
       handleViewMessages={() => {
        setViewRows(selectedRowsWithDetails);
        //setDrawer(true)
      }}
     
       handleUnselectAll={() => {
         setSelectedRows([]);
        
       }}
       {...{ anchorEl, setAnchorEl, handleShowColumns }}
          />
        </Grid>
        <Grid item xs={12} ref={(newTableRef) => setTableRef(newTableRef)}>
          <CustomTable
            {...{
              pageSize,
              pageNumber,
              totalItems,
              totalPages,
              columns,
              tableRef,
              updatedAt,
              loading: processing,
              onSelectionChange,
              selectedRows,
              onRowClick,
              handleColumnHide,
              onPaginationChange: handlePaginationChange,
            }}
            DynamicHeight ={() => 'auto'}
            rows={Rows}
          />
        </Grid>
      </Grid>

      {isActiveOpen.status && (
        <ActivateCustomers
        
          open={isActiveOpen}
          onClose={SethandleActivateCustomersOpen}
          rows={selectedRowsWithDetails}
          error={error}
          success={success}
          ActiveUser={ActiveUser}
          handleUnselectAll={() => {
            setSelectedRows([]);
           
          }}
        />
      )}


{isAssginOpen && (
  <AssginCustomers
          open={isAssginOpen}
          onClose={() => SethandleIsAssginOpen(false)}
          touched={touched}
          action={() => formik.handleSubmit()}
  >
  <>
      <InputLabel sx={styleLabel}>
      Select Groups 
    </InputLabel>
<FormikMultiple
 options={[...Groups]}
isOptionEqualToValue ={ (option, value) => option.id === value.id}
getOptionLabel={(option) => option.name}
value={formik.values.Groups}
name="Groups"
formik={formik}
label="Assign to group"
height={"36px"}
fullWidthFlag={true}
validationOn={true}
setTouched={setTouched}
touched={touched}
error={formik.errors.Groups}
helperText={formik.errors.Groups}
Info="You can assign multiple groups"
/>
          </>


  </AssginCustomers>

)}
</>
  )
}

export default CustomersList